// svg //
import { ReactComponent as CampaignName } from "../../assets/images/svg/CampaignName.svg";
import { ReactComponent as SelectAgent } from "../../assets/images/svg/Agent.svg";
import { ReactComponent as ScheduleTime } from "../../assets/images/svg/ScheduleTime.svg";
import { ReactComponent as CallType } from "../../assets/images/svg/Call.svg";
import { ReactComponent as Feedback } from "../../assets/images/svg/Feedback.svg";
import { ReactComponent as Upload } from "../../assets/images/svg/FileUpload.svg";
import { ReactComponent as Did } from "../../assets/images/svg/Did.svg";


// import { ReactComponent as VerticalConnection } from "../assets/images/svg/VerticalCannection.svg";

// Components //
import Campaignname from "../../components/CreateCampaign/CampaignName";
import Selectagent from "../../components/CreateCampaign/SelectAgent";
import Scheduletime from "../../components/CreateCampaign/ScheduleTime";
import FeedBack from "../../components/CreateCampaign/FeedBack";
import UploadCustomer from "../../components/CreateCampaign/UploadCustomer";
import Calltype from "../../components/CreateCampaign/CallType";
import SelectDid from "../../components/CreateCampaign/Did";

import CreateCampaign from "../Admin/CreateCampaign";

import Swal from "sweetalert2";

// Use State //
import { useEffect, useRef, useState } from "react";

// Axios //
import useAuth from "../../hooks/useAuth";
import UseAxiosPrivate from "../../hooks/useAxiosPrivate";
import axiosService from "../../utils/axios";
import Labels from "../../components/CreateCampaign/Labels";
import axios from "axios";

// Location//
import { useNavigate, useLocation } from "react-router-dom";
import { TopDisappearingMessage } from "../../utils/Common";
const CAMPAIGN_URL = "/contactcentre/NewAddCampaign/";

const NewCampaign = (props) => {
  const navigate = useNavigate();

  const location = useLocation();
  const pathArray = location.pathname.split("/");
  const campaignId = pathArray.pop();
  const [ExcelCount,SetExcelCount] =useState(0);

  console.log(campaignId, "location1111111");

  // Set Error Maessage //
  const [errormsg, setErrormsg] = useState("");

  // user id //
  const user = useAuth();
  const user_id = user.auth.user_details.id;

  // ========================  Getting Angets ============================ //

  // Agnet users //
  const [agent, agentData] = useState({});
  const [agentDataLoading,setAgentDataLoading] = useState('false');
  const isFirstLoad =  useRef(true);

  const [scheduledTimeChanged,setScheduledTimeChanged] = useState(false);
  const [agentDataChanged,setAgentDataChanged] = useState(false);

  const getAgnetNames = async () => {
    if(isFirstLoad.current){
      setAgentDataLoading('true');
    }
    const response = await axiosprivate.get(
      "/contactcentre/agent_names/" + user_id + "/",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth?.accessToken}`,
        },
        withCredentials: true,
      }
    );
    agentData(response.data);
    if(isFirstLoad.current){
      setAgentDataLoading('false');
      isFirstLoad.current = false;
    }
  };
  
  // Get Dids //
  const [dids, setDid] = useState({});
  const getDids = async () => {
    let selected_did = data?.dids?.[0] || "";
    const response = await axiosprivate.get(
      "/contactcentre/get_did/" + user_id + "/",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth?.accessToken}`,
        },
        withCredentials: true,
        params: {
          "predictive_dialer": data.predictiveDialer,
          'did': selected_did
        },
      }
    );
    // alert(JSON.stringify(response.data))
    setDid(response.data);
  };

  // ======================== End  Getting Angets ============================ //

  // Active page
  const [active, setActive] = useState("CampaignName");

  const handleChange = (e) => {
    getAgnetNames();
    setActive(e);
    console.log("data ----------->  ",data)
    if (e == "SelectDid") {
      getDids();
    }
    console.log("ACTIVE -----", active);
  };

  // Data for send to backend //
  const [data, setData] = useState({
    campaignId: "",
    campaign_name: "",
    agents: [],
    dids: [],
    caller_id_mode : null,
    schedule_time: [],
    call_type: "",
    questions: [],
    file: "",
    invalidFile: "",
    labels: [],
    customerNumberMask: false,
    did: "",
    campaignStartTime: "",
    nextCallTime: "",
    maxRetry: "",
    progressiveDialer: false,
    predictiveDialer: false,
    customer_ratio: "",
    voice_boat_template: "",
    voice_bot_call_limit: 1,
    retry_type: "",
    retry_interval_value: "",
    retry_time_gap: "Fixed",
    retry_schedule_data: [],
    campaign_template: false,
  });

  useEffect(() => {
    getAgnetNames();
    getDids()
  }, [active, data.dids]);

  //######### Send Campaign Data to Backend #########//

  const { auth, setAuth } = useAuth();
  const axiosprivate = UseAxiosPrivate();

  useEffect(() => {
    if (!data.predictiveDialer) return;
    if (!Array.isArray(data.dids) || data.dids.length <= 1) return;

    const channelSet = new Set(data.dids.map(d => d.channelId));

    if (channelSet.size > 1) {
      Swal.fire({
        icon: "warning",
        title: "Enable Predictive Dialing?",
        // text:
        //   "Predictive dialing works best when DIDs are from the same group. You can review and adjust your selected DIDs before converting to predictive dialing.",
        html:  `
    <ul style="
      text-align:left;
      padding-left:20px;
      list-style-type: disc;
      padding-inline-
    ">
      <li>Predictive dialing works best when all selected DIDs are from the same group.</li>
      <li>You can review and adjust your selected DIDs before converting to predictive dialing.</li>
      <li>If the selection is not valid, you will be asked to reselect your DIDs.</li>
    </ul>
  `,
        confirmButtonText: "Clear DIDs",
        cancelButtonText: "Cancel & Re-check",
        showCancelButton:true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if(result.isConfirmed){
          setData(prev => ({
            ...prev,
            dids: []
          }));
          setActive("SelectDid");
        }
        if(result.dismiss===Swal.DismissReason.cancel){
          setData(prev => ({
            ...prev,
            predictiveDialer: false
          }));
          setActive("SelectDid");
        }
      });
    }
  }, [data.predictiveDialer]);


  const sendCampaignDataToBackend = async () => {

    try {
      const error_message = {
        campaign_name: "Please provide a valid name for the campaign.",
        agents: "Please select an agent for the campaign.",
        schedule_time:"Please select a Schedule Time for the campaign.",
        call_type:"Please select a Call Type for the campaign.",
        dids:"Please select a DID for the campaign.",
        file: "Please Upload Excel for the campaign.",
      }

      if (data.call_type == "voice-bot" && data.voice_boat_template == "") {
        Swal.fire({
          icon: "error",
          title: "Campaign Creation Failed",
          text: "Please choose a template",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        })
        return;
      }

      if (data.predictiveDialer && data.customer_ratio == "") {
        Swal.fire({
          icon: "error",
          title: "Campaign Creation Failed",
          text: "Please provide customer ratio",
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        })
        handleChange("CallType")
        return;
      }

      for (const field in error_message) {
        if (field === "schedule_time") continue;
        if(data[field].length===0){
          // alert(`no ${field}`)
          Swal.fire({
            icon:"error",
            title: "Campaign Creation Failed",
            text: error_message[field],
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
          })
          return;
        }
      }

      const formData = new FormData();
      formData.append("userId", user_id);
      formData.append("camid", campaignId);
      formData.append("campaignName", data.campaign_name);
      formData.append("virtualuserids", data.agents);
      // data.dids.forEach(d => {
      //   const did = typeof d === "object" ? d?.did : d;

      //   if (did) {
      //     formData.append("dids", did);
      //   }
      // });
      const didList = data.dids
        .map(d => (typeof d === "object" ? d?.did : d))
        .filter(Boolean) // remove null/undefined
        .join(",");

      formData.append("dids", didList);

      formData.append("caller_id_mode", data.caller_id_mode || "random")
      formData.append("scheduledTime",JSON.stringify(data.schedule_time));
      formData.append("scheduledTimeChanged",scheduledTimeChanged);
      formData.append("campaign_mode", data.call_type);
      formData.append("questions", JSON.stringify(data.questions));
      formData.append("file", data.file);
      formData.append("invalidFile", data.invalidFile);
      formData.append("labeloption", JSON.stringify(data.labels));
      formData.append("customerNumberPermission", JSON.stringify(data.customerNumberMask))
      formData.append("did", data.did);
      formData.append("campaignStartTime", data.campaignStartTime || "3");
      formData.append("nextCallTime", data.nextCallTime || "3");
      formData.append("maxRetry", data.maxRetry);
      formData.append('progressiveDialer', data.progressiveDialer);
      formData.append("predictiveDialer", data.predictiveDialer);
      formData.append("customer_ratio", data.customer_ratio);
      formData.append("voice_boat_template", data.voice_boat_template);
      formData.append("voice_bot_call_limit", data.voice_bot_call_limit);
      formData.append("retry_type", data.retry_type);
      formData.append("retry_interval_value", data.retry_interval_value);
      formData.append("retry_time_gap", data.retry_time_gap);
      formData.append("retry_schedule_data", JSON.stringify(data.retry_schedule_data));
      formData.append("campaign_template", data.campaign_template);

      const response = await axiosService.post(CAMPAIGN_URL, formData);
      // const response = null;
      
      const intervalExcelcount = 3000;

      if (response.data.status === "1") {
        if(ExcelCount>=3000){
          TopDisappearingMessage(
            "top-start",
            intervalExcelcount,
            "warning",
            "The upload may take some time to complete. Please check back later.",
            false
          );
          setTimeout(() => {
            Swal.fire({
              title: "Success",
              text: "Campaign Created",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Move to Campaign List",
            }).then((result) => {
              if (result.isConfirmed) {
                navigate("/admin/campaign/list");
              }
            });
          }, intervalExcelcount+100);
          return()=>clearInterval(intervalExcelcount);
        }else{

            Swal.fire({
              title: "Success",
              text: "Campaign Created",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Move to Campaign List",
            }).then((result) => {
              if (result.isConfirmed) {
                navigate("/admin/campaign/list");
              }
            });
        }
      } else if (response.data.status === "2") {
        Swal.fire({
          title: "Success",
          text: "Campaign Updated",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Move to Campaign List",
        }).then((result) => {
          if (result.isConfirmed) {
            navigate("/admin/campaign/list");
          }
        });
      } else {
        Swal.fire({
          title: "Error",
          text: response.data.error,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.isConfirmed) {
            console.log("");
          }
        });
      }
    } catch (err) {
      if (!err?.response) {
        setErrormsg("No Server Response");
      } else if (err.response?.status === 400) {
        if(err.response?.data?.camp_status == "creation_failed"){
          Swal.fire({
            icon:"error",
            title: "Campaign Creation Failed",
            text: err.response.data.error,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
          })
        }else{
          setErrormsg("Missing Username or Password");
        }
      } else if (err.response?.status === 401) {
        setErrormsg("Unauthorized");
      }
    }
  };

  const UpdateCampaign = async () => {
    let camp_update_data = {
      user_id: auth?.user_details?.user,
      campaignName: campaignId,
    };
    let config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${auth?.accessToken}`,
      },
    };
    await axios
      .post(
        process.env.REACT_APP_API_URL + "/contactcentre/get_campaign_data/",
        camp_update_data,
        config
      )
      .then((res) => {
        setData({
          ...data,
          campaign_name: res.data.campaignName,
          agents: res.data.agents,
          schedule_time: res.data.scheduleTime,
          call_type: res.data.callType,
          file: res.data.file,
          invalidFile:res.data.invalidFile,
          questions: res.data.questions,
          labels: res.data.labels,
          customerNumberMask: res.data.customerNumPermission,
          did: res.data.did,
          dids: res.data.dids,
          caller_id_mode: res.data.caller_id_mode,
          campaignStartTime: res.data.call_interval_time,
          nextCallTime: res.data.next_call_time,
          maxRetry: res.data.maxRetry,
          progressiveDialer: res.data.progressive_dialer,
          predictiveDialer: res.data.predictive_dialer,
          customer_ratio: res.data.customer_ratio,
          voice_boat_template: res.data.voice_boat_template,
          voice_bot_call_limit: res.data.voice_bot_call_limit,
          retry_type: res.data.retry_type,
          retry_interval_value: res.data.retry_interval_value,
          retry_time_gap: res.data.retry_time_gap,
          retry_schedule_data: res.data.retry_schedule_data,
          campaign_template: res.data.campaign_template,
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    if (campaignId !== "0") {
      UpdateCampaign();
    }
  }, []);

  return (
    <div className="p-4 bg-back-white">
      {/* <div className="space-y-2">
        <h1 className="font-bold text-lg">New Campaign</h1>
        <p className="text-md text-slate-400">
          Follow the simple steps to add new campaign
        </p>
      </div> */}
      <div className="antialiased p-4 mt-6 grid grid-cols-4">
        <div className="flex sm:space-x-0 md:space-x-6 col-span-1">
          <ul className="space-y-12 mt-4 flex-shrink-0 relative hidden md:block overflow-y-auto no-scrollbar">
            <li className="text-slate-400 font-bold text-md p-3">
              Campaign Name
            </li>
            <li className="text-slate-400 font-bold text-md p-3">
              Select Agent
            </li>
            <li className="text-slate-400 font-bold text-md p-3 pt-[17px]">
              Schedule Time
            </li>
            <li className="text-slate-400 font-bold text-md p-3 pt-[13px]">
              Call Type
            </li>
            <li className="text-slate-400 font-bold text-md p-3">
              Select Did
            </li>
            <li className="text-slate-400 font-bold text-md p-3 pt-[10px]">
              Upload Customers
            </li>

            <li className="text-slate-400 font-bold text-md p-3 pt-[22px]">
              Feedback Questions
            </li>
          </ul>
          <ul className="mt-4 h-full w-full">
            <div
              key={"CampaignName"}
              className="select-none bg-gray-300 p-3 rounded-full h-10 w-10 flex justify-center items-center border-slate-900 border-spacing-6"
              onClick={() => handleChange("CampaignName")}
            >
              {active === "CampaignName" ? (
                <CampaignName fill="#01B375" />
              ) : (
                <CampaignName fill="#919197" />
              )}
            </div>
            <div className="h-[60px] bg-[#BFC7CD] w-[0.5px] ml-[19px]"></div>
            
            <div className="relative w-10 h-10 ">
                <div
                key={"SelectAgent"}
                className={`bg-gray-300 rounded-full w-10 h-10 p-3 flex justify-center items-center ${agentDataLoading==='true'? 'pointer-events-none':''}`}
                onClick={() => handleChange("SelectAgent")}
              >
                {active === "SelectAgent" ? (
                  <SelectAgent
                    fill="#01B375"
                    agent={agent}
                    setData={setData}
                    agents={data.agents}
                    agentDataLoading={agentDataLoading}
                    setAgentDataLoading={setAgentDataLoading}
                  />
                ) : (
                  <SelectAgent fill="#919197" />
                )}
              </div>
              <div className="absolute top-0 left-[-0.4rem] px-2 py-1 rounded opacity-[0.75]">

                {agentDataLoading=='true'? 
                // {agent? 
                
                <div className="flex justify-center rounded-md p-2 cursor-pointer  text-gray-300 text-sm items-center gap-x-4 pe-3 ">
                  <svg
                    className="w-5 h-5 animate-spin text-blue-600"
                    viewBox="0 0 50 50"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      className="opacity-25"
                      cx="25"
                      cy="25"
                      r="17"
                      stroke="currentColor"
                      strokeWidth="10"
                      fill="none"
                    />
                    <circle
                      className="opacity-75"
                      cx="25"
                      cy="25"
                      r="17"
                      stroke="currentColor"
                      strokeWidth="10"
                      strokeLinecap="round"
                      fill="none"
                      strokeDasharray="31.4 188.4"
                    />
                  </svg>

                </div>
                :
                <></>
                }
                

              </div>
            </div>


            <div className="h-[60px] bg-[#BFC7CD] w-[0.5px] ml-[19px]"></div>
            <div
              key={"ScheduleTime"}
              className="bg-gray-300 rounded-full w-10 h-10 p-3 flex justify-center items-center"
              onClick={() => handleChange("ScheduleTime")}
            >
              {active === "ScheduleTime" ? (
                <ScheduleTime fill="#01B375" />
              ) : (
                <ScheduleTime fill="#919197" />
              )}
            </div>
            <div className="h-[58px] bg-[#BFC7CD] w-[0.5px] ml-[19px]"></div>
            <div
              key={"CallType"}
              className="bg-gray-300 rounded-full w-10 h-10 p-3 flex justify-center items-center"
              onClick={() => handleChange("CallType")}
            >
              {active === "CallType" ? (
                <CallType fill="#01B375" />
              ) : (
                <CallType fill="#919197" />
              )}
            </div>
            <div className="h-[60px] bg-[#BFC7CD] w-[0.5px] ml-[19px]"></div>
            <div
              key={"SelectDid"}
              className="bg-gray-300 rounded-full w-10 h-10 p-3 flex justify-center items-center"
              onClick={() => handleChange("SelectDid")}
            >
              {active === "SelectDid" ? (
                <Did
                  fill="#01B375"
                  agent={agent}
                  setData={setData}
                  agents={data.dids}
                />
              ) : (
                <Did fill="#919197" />
              )}
            </div>
            <div className="h-[58px] bg-[#BFC7CD] w-[0.5px] ml-[19px]"></div>
            <div
              key={"Upload"}
              className="bg-gray-300 rounded-full w-10 h-10 p-3 flex justify-center items-center"
              onClick={() => handleChange("Upload")}
            >
              {active === "Upload" ? (
                <Upload fill="#01B375" />
              ) : (
                <Upload fill="#919197" />
              )}
            </div>
            <div className="h-[58px] bg-[#BFC7CD] w-[0.5px] ml-[19px]"></div>
            <div
              key={"Labels"}
              className="bg-gray-300 rounded-full w-10 h-10 p-3 flex justify-center items-center"
              onClick={() => handleChange("Labels")}
            >
              {active === "Labels" ? (
                <Feedback fill="#01B375" />
              ) : (
                <Feedback fill="#919197" />
              )}
            </div>
          </ul>
        </div>
        <div className="col-span-3">
          <div>
            {active === "CampaignName" && (
              <Campaignname
                setActive={setActive}
                next="SelectAgent"
                back={props.SetOpenNewCampaign}
                setData={setData}
                data={data}
                agentData={agentData}
                cName={data.campaign_name}
                agentDataLoading={agentDataLoading}
                setAgentDataLoading={setAgentDataLoading}
              />
            )}

            {active === "SelectAgent" && (
              <Selectagent
                setActive={setActive}
                next="ScheduleTime"
                back="CampaignName"
                agent={agent}
                setData={setData}
                agents={data.agents}
                setAgentDataChanged={setAgentDataChanged}
              />
            )}

            {active === "ScheduleTime" && (
              <Scheduletime
                setActive={setActive}
                next="CallType"
                back="SelectAgent"
                setData={setData}
                scheduleTime={data.schedule_time}
                setScheduledTimeChanged={setScheduledTimeChanged}
              />
            )}
            {active === "CallType" && (
              <Calltype
                setActive={setActive}
                next="SelectDid"
                back="ScheduleTime"
                setData={setData}
                callType={data.call_type}
                customerNumberMask={data.customerNumberMask}
                progressiveDialer={data.progressiveDialer}
                predictiveDialer={data.predictiveDialer}
                nextCallTime={data.nextCallTime}
                campaignStartTime={data.campaignStartTime}
                time={data.time}
                maxRetry={data.maxRetry}
                customer_ratio={data.customer_ratio}
                voice_boat_template={data.voice_boat_template}
                voice_bot_call_limit={data.voice_bot_call_limit}
                retry_type={data.retry_type}
                retry_interval_value={data.retry_interval_value}
                retry_time_gap={data.retry_time_gap}
                retry_schedule_data={data.retry_schedule_data}
              />
            )}
            {active === "SelectDid" && (
              <SelectDid
                setActive={setActive}
                next="Upload"
                back="CallType"
                dids={dids}
                setData={setData}
                did={data.dids}
                caller_id_mode={data.caller_id_mode}
                predictiveDialer={data.predictiveDialer}
              />
            )}
            {active === "Upload" && (
              <UploadCustomer
                setActive={setActive}
                SetExcelCount={SetExcelCount}
                back="SelectDid"
                next="Labels"
                setData={setData}
                feedBack={data.questions}
                file={data.file}
                invalidFile={data.invalidFile}
              />
            )}

            {active === "Labels" && (
              <Labels
                setActive={setActive}
                back="Upload"
                setData={setData}
                sendCampaignDataToBackend={sendCampaignDataToBackend}
                SetOpenNewCampaign={props.SetOpenNewCampaign}
                labels={data.labels}
                questions={data.questions}
                campaign_template={data.campaign_template}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default NewCampaign;
